import {log} from 'common/log'
import Promise from 'bluebird'
import axios from 'axios'
import moment from 'moment'
import _ from 'lodash'
import {BehaviorSubject, merge, Subject, timer} from 'rxjs';
import {filter, first, map, switchMap} from 'rxjs/operators';
import {auditDocumentVisible} from 'util/rxjsOperators/auditDocumentVisible';
import {toastServerError} from 'module/Error/Toast';

export const openHelp = () => window.open('https://help.sisevo.com/benutzeranleitung/handbuch?sharedUser=epze', '_blank').focus();

export const logout = () => window.open('./j_spring_security_logout', '_self');

let currentlyRunning = null;
export const fetchSessionInfo = () => {
	currentlyRunning = axios.get("../json/evoAppsUserInfoDialogController/load-EvoAppsUserInfoTO");
	currentlyRunning.then(() => currentlyRunning = null).catch(() => currentlyRunning = null);
	return currentlyRunning;
}

const validityDuration = moment.duration(5, 'minutes');
let nextRefresh = null;

const forceRefresh$ = new Subject();
export const forceRefreshSessionInfo = () => forceRefresh$.next({force: true});

export const sessionInfo$ = new BehaviorSubject(null);
export const sessionInfoInitializedP = sessionInfo$.pipe(filter(x => x), first()).toPromise();
const sessionInfoUnfilteredRequest$ = new Subject(null);

export const doAfterNextSessionInfoRefreshDone = (action) => sessionInfoUnfilteredRequest$.pipe(first()).subscribe(() => {
	if (typeof action === 'function') action();
});

merge(
	forceRefresh$,
	timer(0, 15000),
).pipe(
	filter(({force} = {}) => !currentlyRunning && (force || !nextRefresh || nextRefresh.isBefore(moment()))),
	auditDocumentVisible(),
	switchMap(() => Promise.resolve(fetchSessionInfo())
		.catch(err => {
			log.error("Error while fetching session info", err);
			toastServerError(err);
			return []
		})),
	map((resp) => {
		nextRefresh = moment().add(validityDuration);
		const data = resp && resp.data;
		if (data && !_.isEqual(sessionInfo$.value, data)) sessionInfo$.next(data);
		sessionInfoUnfilteredRequest$.next(data);
		return data;
	}),
).subscribe((x) => {
	log.debug("refresh observable result", x)
}, (err) => {
	log.error("error", err)
});


/* deprecated getters - remove synchronous usage of these methods */
/** @deprecated */
export const getCurrentUserId = () => sessionInfo$.value.evoAppsUser.username;
/** @deprecated */
export const getCurrentUserPersNr = () => sessionInfo$.value.evoAppsUser.persNr;
/** @deprecated */
export const getCurrentUserIdLong = () => sessionInfo$.value.evoAppsUser.longUsername;
/** @deprecated */
export const getCurrentUserGroupId = () => sessionInfo$.value.evoAppsUser.userGroup.id;
/** @deprecated */
export const getCurrentUserMandant = () => sessionInfo$.value.evoAppsUser.mandant;
/** @deprecated */
export const isCurrentUserAlternative = () => sessionInfo$.value.evoAppsUser.alternativeUser;